"use strict";

import BaseModel from "@/shared/lib/client-sdk/base-model";

class PlanTrustee extends BaseModel {
  constructor(idOrAttributes, onRefreshCallback = null) {
    super(idOrAttributes, onRefreshCallback);
  }

  static getModelClassName() {
    return "PlanTrustee";
  }

  static getApiPathForSearch() {
    console.error("Cannot search plan trustees.");
  }

  getApiPathForCreate() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/plans/" +
      this.planId +
      "/trustees"
    );
  }

  getApiPathForRefreshUpdateAndDelete() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/plan-trustees/" +
      this.id
    );
  }

  getAdminPath() {
    console.error("Cannot go to a plan trustee.");
  }

  get searchResultTitle() {
    return null;
  }

  // Returns a string, or an array of strings (for a multi-line subtitle)
  get searchResultSubtitle() {
    return null;
  }

  get searchResultCreatedAt() {
    return null;
  }

  get searchResultStatus() {
    return null;
  }
}

export default PlanTrustee;
